import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import Grid from "@mui/material/Grid";



const CheckPeerPage = ({ peerInfo, onStateChange }) => {
    
   // const {socetInfo} = props;

    console.log('peerInfo', peerInfo);
    //console.log('socetInfo',  ['null', '', null, undefined].includes(socetInfo.err));
   

    function nextButtonClick(){
        
        onStateChange(true); // Вызываем функцию обратного вызова
    }

    
    return (
        <div  >
        <h2>{}Проверка связи с медиасервером</h2>
  
          <br/>
          <p style={{color: 'red'}}>
          {peerInfo.err ===null ? '': peerInfo.err}
          </p>
  
        <div style={{display: 'flex',  textAlign: 'center', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>

       
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
          <Grid item sx={{color:'gray'}}>{'Статус соединения:'}</Grid>
          <Grid item >{
            peerInfo.conectedToServer === true ? 
            <p style={{color: 'green'}}>Успешно соединен</p>
            : 

            <p style={{color: 'red'}}>Соединение отсутствует</p>
          }</Grid>
        </Grid>
   
        {
            peerInfo.conectedToServer===true && ['null', '', null, undefined].includes(peerInfo.err)===true ? 
            <>
            <br/>    <br/> 
            <Button  
            onClick={nextButtonClick}
            variant="contained"  sx={{ borderRadius: '16px',  background: 'green', minWidth: '150px'}}>
                Далее
            </Button>
            </>
       
            : <></>

        }
         </div>
        
      </div>
    );
  };


  export default CheckPeerPage;
